import { Outlet } from "react-router-dom";
import heroImage from "@/assets/images/hero-bg.jpg";
import { Typography } from "antd";
import { usePageTitle } from "@/hooks/use-page-title";
import ENV from "@/config/env";

const { Text } = Typography;

export default function MainLayout() {
  usePageTitle();

  return (
    <div
      className="min-h-screen relative px-4 py-10 sm:py-14"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <main>
        <Outlet />

        <Text
          style={{
            color: "#EEE",
            fontWeight: 500,
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            width: "100%",
            display: "block",
            textAlign: "center",
          }}
        >
          Sebuah inisiatif{" "}
          <Text strong style={{ color: "#EEE" }}>
            Lembaga Pembangunan Tioman
          </Text>
        </Text>
      </main>

      {ENV.environment !== "production" && (
        <div
          style={{
            position: "fixed",
            bottom: 16,
            right: 16,
            textAlign: "center",
            fontSize: 12,
            borderRadius: 999,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "#EEE",
            padding: "4px 16px",
            fontWeight: 500,
          }}
        >
          {ENV.environment.toUpperCase()}
        </div>
      )}
    </div>
  );
}
